import * as React from "react";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  Backdrop,
  Card,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  Select,
  TablePagination,
} from "@mui/material";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import colors from "assets/theme/base/colors";

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const tableStyle = { fontSize: "13.5px" };

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell sx={tableStyle}>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row" sx={tableStyle}>
          {row.id}
        </TableCell>
        <TableCell align="left" sx={tableStyle}>
          {row.name}
        </TableCell>
        <TableCell align="center" sx={tableStyle}>
          {parseInt(row.qualificationTypeId) === 1
            ? "Multi Select"
            : parseInt(row.qualificationTypeId) === 2
              ? "Single Select"
              : "Text Input"}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 2 }}>
              <Table
                size="small"
                aria-label="purchases"
                sx={{
                  background: "rgba(230, 247, 253, 1)",
                  "& th": {
                    fontSize: "14px",
                  },
                }}
              >
                <TableHead style={{ display: "table-header-group" }}>
                  <TableRow>
                    <TableCell sx={{ fontSize: "13.5px", fontWeight: "900" }}>
                      Q :&nbsp;{row.qualificationQuestion.questionText}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <Grid container spacing={2}>
                        {row.qualificationQuestion.answers.map((value, i) => {
                          return row.qualificationTypeId === 1 ||
                            row.qualificationTypeId === 2 ? (
                            <Grid item xs={12} md={3} key={i} sx={tableStyle}>
                              <FormControlLabel
                                control={<Checkbox />}
                                label={
                                  <MDTypography
                                    variant="button"
                                    sx={{
                                      cursor: "pointer",
                                      userSelect: "none",
                                      ml: 0.5,
                                      fontSize: "13.5px",
                                    }}
                                  >
                                    {value.qualificationAnswerDesc}
                                  </MDTypography>
                                }
                              />
                            </Grid>
                          ) : (
                            <>
                              <Grid item xs={12} md={3} key={i} sx={tableStyle}>
                                <MDInput
                                  type="number"
                                  autoComplete="off"
                                  variant="outlined"
                                  label="min"
                                  size="small"
                                  fullWidth
                                  required
                                />
                              </Grid>
                              <Grid item xs={12} md={3} key={i} sx={tableStyle}>
                                <MDInput
                                  type="number"
                                  autoComplete="off"
                                  variant="outlined"
                                  label="max"
                                  size="small"
                                  fullWidth
                                  required
                                />
                              </Grid>
                            </>
                          );
                        })}
                      </Grid>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default function CollapsibleTable({
  qualification,
  isLoading,
  language,
  setLanguageId,
  languageId,
  setSearch,
  setCheck,
}) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const { info, textColor, primary } = colors;

  const tableStyle = { fontSize: "13px", fontWeight: "700", color: textColor.main };
  const [tab, setTab] = React.useState("Standard");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container spacing={1} pb={1} mb={1}
        sx={{
          // flexDirection: { xs: "column", md: "row" },
          // alignItems: { xs: "flex-end", md: "center" },
          borderBottom: `2px solid ${primary.main}`,
        }}
      >
        <Grid
          px={0}
          item
          xs={2}
          md={2}
          display="flex"
          alignItems={"center"}
          flexDirection="row"
          sx={{
            // flexDirection: { xs: "column", md: "row" },
            // alignItems: { xs: "flex-end", md: "center" },
          }}
          gap="15px"
        >
          <MDTypography fontSize="22px" color="black" >
            Qualifications
          </MDTypography>
        </Grid>
        <Grid
          px={1}
          item
          xs={10}
          md={10}
          display="flex"
          justifyContent="flex-end"
          flexDirection="row"
          sx={{
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "flex-end", md: "center" },
          }}
          gap="15px"
        >
        </Grid>
      </Grid>
      <MDBox my={2} marginTop="1.5rem" borderRadius="5px" bgColor="white" width="100%">
        <Grid
          container
          spacing={1}
          pb={2}
          pl={2}
          pr={2}
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid item xs={12} md={2}>

          </Grid>

          <Grid
            item
            xs={12}
            md={10}
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="right"
          >
            <Grid item xs={12} md={4}>
              <MDBox
                display="flex"
                justifyContent="right"
                pr={3}
                alignItems="center"
                flexDirection="row"
              >
                <MDBox
                  className="tab"
                  onClick={() => {
                    setTab("All");
                    setCheck(true);
                  }}
                  bgColor={tab === "All" ? "white" : ""}
                  color={tab === "All" && `info`}
                  style={{
                    border:
                      tab === "All" ? `1px solid ${info.main}` : "1px solid rgba(217, 217, 217, 1)",

                    cursor: "pointer",
                  }}
                >
                  All
                </MDBox>
                <MDBox
                  className="tab"
                  onClick={() => {
                    setTab("Standard");
                    setCheck(false);
                  }}
                  bgColor={tab === "Standard" ? "white" : ""}
                  color={tab === "Standard" && `info`}
                  style={{
                    border:
                      tab === "Standard"
                        ? `1px solid ${info.main}`
                        : "1px solid rgba(217, 217, 217, 1)",

                    cursor: "pointer",
                  }}
                >
                  Standard
                </MDBox>
                <MDBox
                  className="tab"
                  // onClick={() => setTab("Custom")}
                  bgColor={tab === "Custom" ? "white" : ""}
                  style={{
                    border:
                      tab === "Custom"
                        ? `1px solid ${info.main}`
                        : "1px solid rgba(217, 217, 217, 1)",
                    color: tab === "Custom" && "rgba(129, 176, 60, 1)",
                    cursor: "pointer",
                  }}
                >
                  Custom
                </MDBox>
              </MDBox>
            </Grid>
            <Grid item xs={12} md={2} pr={3}>
              <FormControl fullWidth>
                <Select
                  value={languageId}
                  onChange={(e) => {
                    setLanguageId(e.target.value);
                  }}
                >
                  {language.map((value, i) => (
                    <MenuItem value={value.id} key={i}>
                      {value.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={2}>
              <MDInput
                type="text"
                autoComplete="off"
                variant="outlined"
                label="Search"
                fullWidth
                size="small"
                required
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        {/* <Card> */}
        <TableContainer component={Paper} sx={{ paddingTop: "0px", height: "calc(100vh - 210px)", width: "100%" }}>
          <Table
            aria-label="collapsible table"
            style={{ color: "black" }}
            sx={{
              overflow: "auto",
              "& th": {
                fontSize: "14px",
              },
              "& .MuiTableCell-root": {
                fontSize: "14px",
                fontWeight: "400",
              },
            }}
          >
            <TableHead style={{ display: "table-header-group" }}>
              <TableRow>
                <TableCell style={{ width: "2%" }} />
                <TableCell sx={tableStyle} style={{ width: "10%" }}>
                  Qualification Id
                </TableCell>
                <TableCell sx={tableStyle} align="left">
                  Qualification Name
                </TableCell>
                <TableCell sx={tableStyle} align="center">
                  Qualification Type
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody style={{ color: "black" }}>
              {qualification
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => (
                  <Row key={row.id} row={row} />
                ))}
            </TableBody>
          </Table>
          <Grid item xs={12} p={2}>
            <TablePagination
              component="div"
              count={Math.round(qualification.length / 10)}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[10]}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Grid>
        </TableContainer>
        {/* </Card> */}
      </MDBox>
    </>
  );
}
